module.exports = __webpack_public_path__ + "static/img/IMG_20241023_172042.accfb62e.jpg";